import { REQUEST, FAILURE, SUCCESS } from 'redux-config/reduxHelpers';
import * as ActionTypes from './actions';

export const initialState = {
  countries: [],
  countriesAreLoaded: false,

  states: [],
  statesAreLoaded: false,

  kycValues: {},
  kycValuesAreLoaded: false,

  documentsReupload: {
    identification_proof: false,
    passport: false,
    passport_with_face: false,
    address_proof: false,
    additional_document: false,
  },
  documentsUploadErrors: {},

  // 每类文档已上传的文件列表：{ [docTypeName]: [{ id, type, status, side, poi_doc_type }] }
  documents: {},

  notificationSettings: {},
  notificationSettingsAreLoaded: false,

  agreements: [],
  agreementsAreLoaded: false,

  cards: [],
  cardsAreLoaded: false,

  card: {},
  cardIsLoaded: false,

  deleteCardError: {},

  sumSubToken: '',
  sumSubTokenIsLoaded: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_COUNTRIES[REQUEST]:
      return { ...state, countriesAreLoaded: false };
    case ActionTypes.GET_COUNTRIES[SUCCESS]:
      return { ...state, countries: action.data, countriesAreLoaded: true };
    case ActionTypes.GET_COUNTRIES[FAILURE]:
      return { ...state, error: action.error, countriesAreLoaded: false };

    case ActionTypes.GET_STATES[REQUEST]:
      return { ...state, statesAreLoaded: false };
    case ActionTypes.GET_STATES[SUCCESS]:
      return { ...state, states: action.data, statesAreLoaded: true };
    case ActionTypes.GET_STATES[FAILURE]:
      return { ...state, error: action.error, statesAreLoaded: false };

    case ActionTypes.GET_KYC[REQUEST]:
      return { ...state, kycValuesAreLoaded: false };
    case ActionTypes.GET_KYC[SUCCESS]: {
      const sections = ['forex', 'derivative', 'securities', 'investmentFund'];
      sections.forEach(section => {
        if (!!action.data.experience[section] && Object.keys(action.data.experience[section]).length > 0) {
          action.data.experience[section].checkbox = true;
        }
      });
      // 兼容旧的post_code字段名，转换为postCode
      if (action.data.address && action.data.address.post_code && !action.data.address.postCode) {
        action.data.address.postCode = action.data.address.post_code;
      }

      return { ...state, kycValuesAreLoaded: true, kycValues: action.data };
    }
    case ActionTypes.GET_KYC[FAILURE]:
      return { ...state, kycValuesAreLoaded: false };

    case ActionTypes.SEND_DOCUMENTS[REQUEST]:
      return { ...state };
    case ActionTypes.SEND_DOCUMENTS[SUCCESS]: {
      const errors = { ...state.documentsUploadErrors };
      delete errors[action.name];
      const reupload = { ...state.documentsReupload };
      reupload[action.name] = false;
      return {
        ...state,
        documentsUploadErrors: errors,
        documentsReupload: reupload,
      };
    }
    case ActionTypes.SEND_DOCUMENTS[FAILURE]:
      return {
        ...state,
        documentsUploadErrors: {
          ...state.documentsUploadErrors,
          ...action.error,
        },
      };

    case ActionTypes.TOGGLE_REUPLOAD_DOCUMENTS: {
      const toggleReupload = { ...state.documentsReupload };
      toggleReupload[action.name] = !toggleReupload[action.name];
      return { ...state, documentsReupload: toggleReupload };
    }

    case ActionTypes.GET_USER_DOCUMENTS[REQUEST]:
      return { ...state };
    case ActionTypes.GET_USER_DOCUMENTS[SUCCESS]: {
      const { name, list } = action;
      return { ...state, documents: { ...state.documents, [name]: list || [] } };
    }
    case ActionTypes.GET_USER_DOCUMENTS[FAILURE]:
      return { ...state };

    case ActionTypes.DELETE_USER_DOCUMENT[REQUEST]:
      return { ...state };
    case ActionTypes.DELETE_USER_DOCUMENT[SUCCESS]: {
      const { id, name } = action;
      const list = (state.documents[name] || []).filter(doc => doc.id !== id);
      return { ...state, documents: { ...state.documents, [name]: list } };
    }
    case ActionTypes.DELETE_USER_DOCUMENT[FAILURE]:
      return { ...state };

    case ActionTypes.GET_NOTIFICATION_SETTINGS[REQUEST]:
      return { ...state, notificationSettingsAreLoaded: false };
    case ActionTypes.GET_NOTIFICATION_SETTINGS[SUCCESS]:
      return {
        ...state,
        notificationSettings: action.data,
        notificationSettingsAreLoaded: true,
      };
    case ActionTypes.GET_NOTIFICATION_SETTINGS[FAILURE]:
      return {
        ...state,
        error: action.error,
        notificationSettingsAreLoaded: false,
      };

    case ActionTypes.GET_AGREEMENTS[REQUEST]:
      return { ...state, agreementsAreLoaded: false };
    case ActionTypes.GET_AGREEMENTS[SUCCESS]:
      return { ...state, agreements: action.data, agreementsAreLoaded: true };
    case ActionTypes.GET_AGREEMENTS[FAILURE]:
      return { ...state, error: action.error, agreementsAreLoaded: false };

    case ActionTypes.GET_CARDS[REQUEST]:
      return { ...state, cardsAreLoaded: false };
    case ActionTypes.GET_CARDS[SUCCESS]:
      return { ...state, cards: action.data, cardsAreLoaded: true };
    case ActionTypes.GET_CARDS[FAILURE]:
      return { ...state, error: action.error, cardsAreLoaded: false };

    case ActionTypes.GET_CARD[REQUEST]:
      return { ...state, cardIsLoaded: false };
    case ActionTypes.GET_CARD[SUCCESS]:
      return { ...state, card: action.data, cardIsLoaded: true };
    case ActionTypes.GET_CARD[FAILURE]:
      return { ...state, error: action.error, cardIsLoaded: false };

    case ActionTypes.DELETE_CARD[REQUEST]:
      return { ...state };
    case ActionTypes.DELETE_CARD[SUCCESS]:
      return { ...state };
    case ActionTypes.DELETE_CARD[FAILURE]:
      return { ...state, deleteCardError: action.error };

    case ActionTypes.GET_SUM_SUB_TOKEN[REQUEST]:
      return { ...state, sumSubTokenIsLoaded: false };
    case ActionTypes.GET_SUM_SUB_TOKEN[SUCCESS]:
      return { ...state, sumSubToken: action.data, sumSubTokenIsLoaded: true };
    case ActionTypes.GET_SUM_SUB_TOKEN[FAILURE]:
      return { ...state, error: action.error, sumSubTokenIsLoaded: false };

    default:
      return state;
  }
};

export default reducer;
